module.exports = __webpack_public_path__ + "img/presse-foire-europeene-de-strasbourg-sm.bfe1c0b9.jpg";